export const step = 5000
export const timeoutDelay = step
export const initialDelay = 2 * step
export const minDelay = 2 * step
export const maxDelay = 24 * step // 2 mins
